import styled from 'styled-components'

export const PaymentStatusDot = styled.div`
  background: ${({ statusColor }) => statusColor};
  height: 8px;
  width: 8px;
  border-radius: 50%;
`
